export default __webpack_public_path__ + "static/ortho care  ET-1019241f5a92264acf0ed0a62a2a3a70.png";